import { useInfiniteQuery } from "@tanstack/react-query";
import { postApi, type TeabatePostListItem } from "lib/api/posts";

export const teabatePostQueryKeys = {
  dimensionedList: (issueId: number | null) => ["teabates", "dimensioned-list", issueId ?? "all"] as const,
};

interface DimensionedTeabatePage {
  items: TeabatePostListItem[];
  nextOffset?: number;
}

export function useDimensionedTeabatesInfiniteQuery(issueId?: number | null, enabled = true, limit = 20) {
  return useInfiniteQuery<DimensionedTeabatePage>({
    queryKey: teabatePostQueryKeys.dimensionedList(issueId ?? null),
    initialPageParam: 0,
    queryFn: async ({ pageParam }) => {
      const offset = typeof pageParam === "number" ? pageParam : 0;
      const items = await postApi.listDimensionedTeabates({
        issueId: issueId ?? null,
        limit,
        offset,
        sortField: "created_at",
        sortOrder: "DESC",
      });

      return {
        items,
        nextOffset: items.length >= limit ? offset + limit : undefined,
      };
    },
    getNextPageParam: (lastPage) => lastPage.nextOffset,
    enabled,
  });
}
